export const TABS = {
  FAVORITES_LIST: 'favorites-list',
  RECENT_PROFESSIONALS: 'recent-professionals',
  RECOMMENDED_PROS: 'new-to-you',
};

export const TAB_INDEX = {
  FAVORITES_LIST: 0,
  RECENT_PROFESSIONALS: 1,
  RECOMMENDED_PROS: 2,
};
